function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomCityViewFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.82 13.552h-3.218v-.799h3.219v.8zM22 25.538h-3.996v2.397h-1.598V14.351c0-.442.357-.799.8-.799h.798v-1.598c0-.442.358-.799.8-.799h4.817c.442 0 .8.357.8.8v1.597h.798c.442 0 .8.357.8.8v13.583h-1.599V15.15h-6.416v2.398H22v1.598h-3.996v1.598H22v1.598h-3.996v1.598H22v1.598zm-11.164 1.598H8.438v.8H6.84v-9.59c0-.441.357-.798.799-.798h6.392c.442 0 .8.357.8.799v9.588h-1.599v-8.79H8.438v1.599h2.397v1.598H8.438v.799h2.397v1.598H8.438v.8h2.397v1.597zM8.367 9.405c.092 0 .184.017.274.05.38.143.808-.02.993-.383a1.307 1.307 0 011.167-.716c.579 0 1.098.39 1.258.946a.8.8 0 00.768.577h.014a.55.55 0 010 1.1H8.367a.788.788 0 010-1.575zm0 3.173h4.474a2.15 2.15 0 002.148-2.149c0-.992-.677-1.83-1.594-2.075a2.924 2.924 0 00-2.594-1.597c-.883 0-1.697.394-2.242 1.058a2.388 2.388 0 00-2.577 2.377 2.388 2.388 0 002.385 2.386z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.133 3.07a1 1 0 011-1h25.734a1 1 0 011 1v25.86a1 1 0 01-1 1H3.133a1 1 0 01-1-1V3.07zm2 1v23.86h23.734V4.07H4.133z",
    fill: props.color
  }));
}

export default SvgIconRoomCityViewFilled;